export const getPersonsFrag = `
    id
    name
    surname
    titleBeforeName
    titleAfterName
    email
    note
    sex
    validFrom
    validTo
`;
